/* Styled components */

import theme from "@theme/";
import styled from "styled-components";

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
  align-items: stretch;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.95);
  cursor: pointer;
  outline: none;
  transition: box-shadow 160ms ease, transform 120ms ease;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(63, 61, 61, 0.2);
  padding: 0.3rem;
  height: 100%;
  width: 100%;
  min-width: 0;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  }

  &:focus-within {
    outline: 2px solid rgba(227, 110, 0, 0.3);
    outline-offset: 2px;
  }
`;

const CardInner = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;
`;

const Thumb = styled.div`
  height: 72px;
  width: 100%;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 3px;
  background: #f6f6f6;
`;

const ThumbImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const ThumbPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #efefef, #f8f8f8);
`;

const CatalogInfo = styled.div`
  flex: 1 1 auto;
`;
const Title = styled.h3.attrs((props) => ({
  title: props.fulltext, // apply tooltip automatically
}))`
  font-size: 15px;
  margin: 0 0 6px 0;
  color: #222;
  word-wrap: break-word;
`;

const CatalogDate = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
`;

const CatalogCount = styled.div`
  font-size: 13px;
  color: #333;
`;

const CatalogActions = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
`;

const ViewBtn = styled.button`
  background: #f0f0f0;
  border: 1px solid #d0d0d0;
  padding: 6px 12px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;

  &:focus {
    box-shadow: 0 0 0 3px rgba(0, 116, 217, 0.12);
    outline: none;
  }

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const SC = {
  Grid,
  Card,
  CardInner,
  Thumb,
  ThumbImg,
  ThumbPlaceholder,
  CatalogInfo,
  Title,
  CatalogDate,
  CatalogCount,
  CatalogActions,
  ViewBtn,
};

export default SC;
